import { render, staticRenderFns } from "./LoginRedirect.vue?vue&type=template&id=00381be5&scoped=true&"
import script from "./LoginRedirect.vue?vue&type=script&lang=js&"
export * from "./LoginRedirect.vue?vue&type=script&lang=js&"
import style0 from "./LoginRedirect.vue?vue&type=style&index=0&id=00381be5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00381be5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00381be5')) {
      api.createRecord('00381be5', component.options)
    } else {
      api.reload('00381be5', component.options)
    }
    module.hot.accept("./LoginRedirect.vue?vue&type=template&id=00381be5&scoped=true&", function () {
      api.rerender('00381be5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoginRedirect.vue"
export default component.exports